import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  add_gym_landing_page,
  update_gym_landing_page,
} from "../../../data/ApiEndpoints";

const GymLandingPageForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    pageName: isEdit && rowData?.page_name ? rowData.page_name : "",
    pageUrl: isEdit && rowData?.page_url ? rowData.page_url : "",
    keywordName: isEdit && rowData?.keyword ? rowData.keyword : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = (formValues) => {
    let errors = {};
    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/;

    if (!formValues.pageName) {
      errors.pageName = "Required!";
    }

    if (!formValues.pageUrl) {
      errors.pageUrl = "Required!";
    } else if (!urlRegex.test(formValues.pageUrl)) {
      errors.pageUrl = `Invalid route path! A valid route starts with "/" and contains only alphanumeric characters, "-", "_", or "/".`;
    }

    if (!formValues.keywordName) {
      errors.keywordName = "Required!";
    }

    return errors;
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_gym_landing_page : add_gym_landing_page;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        page_name: formValues.pageName ?? "",
        url: formValues.pageUrl ?? "",
        keyword:
          formValues.keywordName?.replace(/ /g, "_")?.toLowerCase() ?? "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Landing Page URL`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="pageName" className={`formInputLabel `}>
              page name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Page Name"
              className={`formInput ${formErrors?.pageName ? "formError" : ""}`}
              name="pageName"
              value={formValues.pageName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="keywordName" className={`formInputLabel `}>
              keyword <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter URL"
              className={`formInput ${
                formErrors?.keywordName ? "formError" : ""
              }`}
              name="keywordName"
              value={formValues.keywordName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="pageUrl" className={`formInputLabel `}>
              Page URL <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter URL"
              className={`formInput ${formErrors?.pageUrl ? "formError" : ""}`}
              name="pageUrl"
              value={formValues.pageUrl}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default GymLandingPageForm;
